import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2287d158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "material-table" }
const _hoisted_2 = { class: "material-table__actions mb15" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("加入待选 >>")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input_search, {
        value: _ctx.keyword,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
        "enter-button": "",
        class: "w300 mr15",
        placeholder: "请输入清单名称关键字",
        onSearch: _ctx.search
      }, null, 8, ["value", "onSearch"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.add
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_a_table, {
      "row-key": "id",
      size: "small",
      bordered: true,
      loading: _ctx.loading,
      "data-source": _ctx.data?.records,
      columns: _ctx.columns,
      scroll: { x: true },
      pagination: false,
      "row-selection": {
        selectedRowKeys: _ctx.selectedIds,
        onChange: _ctx.onSelectionChange,
        fixed: true,
      }
    }, {
      index: _withCtx(({ record, index }) => [
        _createTextVNode(_toDisplayString(index + 1), 1)
      ]),
      _: 1
    }, 8, ["loading", "data-source", "columns", "row-selection"])
  ]))
}